function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { motionValue } from './index.mjs';
import { JSAnimation } from '../animation/JSAnimation.mjs';
import { isMotionValue } from './utils/is-motion-value.mjs';
import { frame } from '../frameloop/frame.mjs';
/**
 * Create a `MotionValue` that animates to its latest value using a spring.
 * Can either be a value or track another `MotionValue`.
 *
 * ```jsx
 * const x = motionValue(0)
 * const y = transformValue(() => x.get() * 2) // double x
 * ```
 *
 * @param transformer - A transform function. This function must be pure with no side-effects or conditional statements.
 * @returns `MotionValue`
 *
 * @public
 */

function springValue(source, options) {
  var initialValue = isMotionValue(source) ? source.get() : source;
  var value = motionValue(initialValue);
  attachSpring(value, source, options);
  return value;
}

function attachSpring(value, source, options) {
  var initialValue = value.get();
  var activeAnimation = null;
  var latestValue = initialValue;
  var latestSetter;
  var unit = typeof initialValue === "string" ? initialValue.replace(/[\d.-]/g, "") : undefined;

  var stopAnimation = function stopAnimation() {
    if (activeAnimation) {
      activeAnimation.stop();
      activeAnimation = null;
    }
  };

  var startAnimation = function startAnimation() {
    stopAnimation();
    activeAnimation = new JSAnimation(_objectSpread(_objectSpread({
      keyframes: [asNumber(value.get()), asNumber(latestValue)],
      velocity: value.getVelocity(),
      type: "spring",
      restDelta: 0.001,
      restSpeed: 0.01
    }, options), {}, {
      onUpdate: latestSetter
    }));
  };

  value.attach(function (v, set) {
    latestValue = v;

    latestSetter = function latestSetter(latest) {
      return set(parseValue(latest, unit));
    };

    frame.postRender(startAnimation);
    return value.get();
  }, stopAnimation);
  var unsubscribe = undefined;

  if (isMotionValue(source)) {
    unsubscribe = source.on("change", function (v) {
      return value.set(parseValue(v, unit));
    });
    value.on("destroy", unsubscribe);
  }

  return unsubscribe;
}

function parseValue(v, unit) {
  return unit ? v + unit : v;
}

function asNumber(v) {
  return typeof v === "number" ? v : parseFloat(v);
}

export { attachSpring, springValue };